import { useState } from "react";
import About from "./Tabs/About";
import Employment from "./Tabs/Employment";
import Education from "./Tabs/Education";

const CustomTabs = (props) => {
  const { resourceDetails } = props;
  const Summary = () => (
    <About
      bio={resourceDetails?.profile_bio}
      resourceSlug={resourceDetails?.user_slug}
    />
  );
  const Experience = () => (
    <Employment
      employment_details={resourceDetails?.employment_details}
      resourceSlug={resourceDetails?.user_slug}
    />
  );
  const EducationTab = () => (
    <Education
      educationDetails={resourceDetails?.education_details}
      resourceSlug={resourceDetails?.user_slug}
    />
  );

  const allTabComponents = {
    Summary,
    Experience,
    Education: EducationTab,
  };

  // Determine which tabs to show
  const filteredTabComponents = allTabComponents;

  const tabNames = Object.keys(filteredTabComponents);
  const [activeTab, setActiveTab] = useState(tabNames[0]); // first available tab

  const ActiveComponent = filteredTabComponents[activeTab];

  return (
    <div className="py-3">
      <div className="d-flex gap-2 p-2 rounded border bg-light overflow-auto">
        {tabNames.map((tab) => (
          <button
            key={tab}
            className={`btn px-3 py-1 rounded-pill fw-medium ${
              activeTab === tab ? "btn-primary text-white" : "text-dark"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-4">
        {ActiveComponent ? (
          <ActiveComponent />
        ) : (
          <div>No content available.</div>
        )}
      </div>
    </div>
  );
};

export default CustomTabs;
